module.exports = __webpack_public_path__ + "media/images/icons/play-c32739a05e2d094e6da5c90dfba20133.svg";